import React from 'react';
import { GameContent } from '../gameContent';
import { RoundTimer } from '../../components/roundTimer';
import { WinPopup } from '../../components/winPopup';

function GameCenterSide() {
  return (
    <div className='gameCenterWrapper'>
      <WinPopup />
      <RoundTimer />

      <div className='gameCenterWrapperInner'>
        <GameContent />
      </div>
    </div>
  );
}

export default GameCenterSide;
